import { useEffect } from 'react';

let isConsentInitialized = false;
let isFirstConsentSet = false;
let isConsentDialogOpen = false;

const useConsentProperty = () => {
  const propertyKey = '55d-azure-user-tracking-consent';
  const isKeyPresentInProperties = window.localStorage.getItem(propertyKey) !== null;

  const initializePropertyData = () => {
    if (!isKeyPresentInProperties) {
      isFirstConsentSet = true;
      isConsentDialogOpen = true;
    }
    isConsentInitialized = true;
  };

  useEffect(() => {
    if (isConsentInitialized) return;
    initializePropertyData();
  }, []);

  const updateProperty = (value) => {
    if (isKeyPresentInProperties) { window.localStorage.removeItem(propertyKey); }
    window.localStorage.setItem(propertyKey, JSON.stringify({ value }));
    return value;
  };

  return {
    updateProperty,
    isConsentDialogOpen,
    isFirstConsentSet,
    setIsFirstConsentSet: (isFirstTime) => {
      isFirstConsentSet = isFirstTime;
      return isFirstConsentSet;
    },
  };
};

export default useConsentProperty;
